export const REASON_KEYS = {
  noAnswer: 'noAnswer',
  irrelevant: 'irrelevant',
  location: 'location',
  incorrect: 'incorrect',
  noImages: 'noImages',
  noNews: 'noNews',
} as const
export const DEFAULT_REASONS = {
  [REASON_KEYS.noAnswer]: 'No answer',
  [REASON_KEYS.irrelevant]: 'Irrelevant answer',
  [REASON_KEYS.location]: 'Wrong location',
  [REASON_KEYS.incorrect]: 'Not factually correct',
  [REASON_KEYS.noImages]: 'No images',
  [REASON_KEYS.noNews]: 'No news',
} as const

export const PANEL_STATES = {
  BUTTON: 'button',
  PANEL: 'panel',
  DONE: 'done',
} as const

export const TEST_IDS = {
  customReasonClear: 'custom-reason-clear',
  insightFeedbackIcon: 'insight-feedback-icon',
  insightFeedbackClose: 'insight-feedback-close',
}
